import ItgenCheckForm from "../../../components/itgen-check-form";

export default class ItgenContractAcceptForm {
    constructor() {
        this.init();
    }

    init() {
        new ItgenCheckForm(document.getElementById('itGenAccept'), {
            emailCheckUri: '/1.0/itgen/sign/email',
            codeCheckUri: '/1.0/itgen/sign/code',
            onComplete: () => {
                document.getElementById('itGenAcceptResult').classList.add('-active');
            }
        });
    }
}